import StyleContext from 'isomorphic-style-loader/StyleContext';
import PropTypes from 'prop-types';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { fetch } from '../hub';
import AppContext from './App-context';

const ContextType = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object,

  // Integrate Redux
  // http://redux.js.org/docs/basics/UsageWithReact.html
  ...ReduxProvider.childContextTypes,
  store: PropTypes.object,
  storeSubscription: PropTypes.object,
  g: PropTypes.object,
};

class App extends React.PureComponent {
  static propTypes = {
    context: PropTypes.shape(ContextType).isRequired,
    children: PropTypes.element.isRequired,
  };

  componentDidMount() {
    const uicssStyles = document.querySelector('#uicss-server-side');
    if (uicssStyles) {
      uicssStyles.parentNode.removeChild(uicssStyles);
    }
  }

  render() {
    const { context } = this.props;
    const {
      context: { store, insertCss },
    } = this.props;
    return (
      <ReduxProvider store={store}>
        <StyleContext.Provider value={{ insertCss }}>
          <AppContext.Provider
            value={{
              ...context,
              fetch: fetch({
                doc: context.g?.document,
                g: context?.g,
              }),
              store,
            }}
          >
            {React.Children.only(this.props.children)}
          </AppContext.Provider>
        </StyleContext.Provider>
      </ReduxProvider>
    );
  }
}

export default App;
